import React from 'react'
import propTypes from 'prop-types'

 const BillSummary = ({ tableData }) => {
  return (
    <div className="col-12 col-lg-5 my-3">
      <div className="card shadow-sm border-0 bill-summary">
        {/* Header */}
        <div className="card-header bg-white border-bottom">
          <h5 className="mb-0 fw-semibold">Bill Summary</h5>
          <small className="text-muted">
            {tableData.zone_type} • {tableData.hours}
          </small>
        </div>

        {/* Body */}
        <div className="card-body">
          {/* Selected Slots */}
          <div className="mb-3 p-2 bg-light rounded">
            <small className="text-muted d-block mb-1">Selected Slots</small>
            <div className="fw-medium">{tableData.slot}</div>
            {tableData.slotCount > 0 && (
              <span className="badge bg-primary mt-1">
                {tableData.slotCount} slot{tableData.slotCount > 1 ? 's' : ''}
              </span>
            )}
          </div>

          {/* Details */}
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Duration</span>
            <span className="fw-medium">{tableData.hours}</span>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Price per Slot</span>
            <span>₹ {tableData.pricePerSlot.toFixed(2)}</span>
          </div>

          {tableData.slotCount > 1 && (
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">
                Slots × Price ({tableData.slotCount} × ₹{tableData.pricePerSlot.toFixed(2)})
              </span>
              <span>₹ {tableData.price.toFixed(2)}</span>
            </div>
          )}

          {tableData.slotCount === 1 && (
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">Base Price</span>
              <span>₹ {tableData.price.toFixed(2)}</span>
            </div>
          )}

          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">
              Tax ({tableData.tax}%)
            </span>
            <span>₹ {tableData.taxAmount.toFixed(2)}</span>
          </div>

          <hr />

          {/* Total */}
          <div className="d-flex justify-content-between align-items-center">
            <span className="fw-semibold fs-6">Total Payable</span>
            <span className="fw-bold fs-5 text-primary">
              ₹ {tableData.total.toFixed(2)}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer bg-light border-0 text-center">
          <small className="text-muted">
            Taxes included • Pay at counter
          </small>
        </div>
      </div>
    </div>
  );
};

BillSummary.propTypes = {
  tableData: propTypes.shape({
    zone_type: propTypes.string,
    hours: propTypes.string,
    slot: propTypes.string,
    slotCount: propTypes.number,
    pricePerSlot: propTypes.number,
    price: propTypes.number,
    tax: propTypes.number,
    taxAmount: propTypes.number,
    total: propTypes.number
  }).isRequired
};

export default BillSummary